<template>
  <b-modal
    :id="id"
    :visible="visible"
    modal-class="guide-modal"
    hide-footer
    hide-header
    centered
  >
    <slot></slot>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      type: String
    },
    visible: {
      type: Boolean
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.guide-modal___BV_modal_content_ {
  border-radius: 16px;
}
</style>
